import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from "@angular/router";
import { CheckoutFlowService } from "./checkout-flow-service";
import { filter, firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class CheckoutStepsGuard implements CanActivate {
  constructor(
    private checkoutFlowService: CheckoutFlowService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    await firstValueFrom(this.checkoutFlowService.fetchAndSetModeFromApi());
    const mode = await firstValueFrom(
    this.checkoutFlowService.mode$.pipe(filter((m): m is string => !!m))
  );

    const config = this.checkoutFlowService.getConfigForMode(mode);
    const routePath = route.routeConfig?.path;

    if (!routePath) return this.router.parseUrl("/cwtcart-detail");

    const currentIndex = config.steps.findIndex((s) =>
      s.routeName.endsWith(routePath)
    );
    if (currentIndex === -1) return this.router.parseUrl("/cwtcart-detail");

    const completedSteps = this.checkoutFlowService.getCompletedSteps(mode);

    const lastCompletedIndex = Math.max(
      ...completedSteps
        .map((step) => config.steps.findIndex((s) => s.routeName === step))
        .filter((i) => i >= 0),
      -1
    );

    if (currentIndex <= lastCompletedIndex + 1) {
      return true; // Allow current or next step
    }

    const fallback =
      config.steps[Math.max(0, lastCompletedIndex + 1)].routeName;
    return this.router.parseUrl(`/${fallback}`);
  }
}
